import React from 'react';

import RiskNameDisplay from '../../../../../../Common/RiskNameDisplay';

const prop = 'riskName';

export default (labels) => ({
	id: `${prop}Column`,
	label: labels[prop],
	propName: prop,
	sortBy: ['riskTypeId', prop],
	width: 'minmax(var(--px-240), 1fr)',
	customCell: ({riskTypeId, riskName}) => {
		const props = {
			typeId: riskTypeId,
			name: riskName,
			multiline: 2
		};

		return <RiskNameDisplay {...props} />;
	}
});
